/* Presentation only: reserve the measured mobile toolbar height for Shopify Forms. */
(() => {
  const mobile = matchMedia('(max-width: 1024px)');
  const root = document.documentElement;
  let frame = 0;
  let toolbar;
  const installed = new WeakSet();
  const floatingCSS = `
    @media (max-width: 1024px) {
      [data-form-root][data-layout="floating"][data-position^="bottom-"] {
        bottom: calc(var(--nekoan-mobile-nav-height, 60px) + 12px) !important;
        max-height: calc(100dvh - var(--nekoan-mobile-nav-height, 60px) - 24px);
        box-sizing: border-box; overflow-y: auto;
      }
      [data-form-root][data-layout="floating"] section[role="dialog"]:not([data-sizing]) {
        top: 0 !important; bottom: calc(var(--nekoan-mobile-nav-height, 60px) + 12px) !important;
        height: auto !important;
      }
      [data-form-root][data-layout="floating"] [data-sizing="form-wrapper"] {
        max-height: calc(100dvh - var(--nekoan-mobile-nav-height, 60px) - 36px) !important;
        overflow-y: auto !important; overscroll-behavior: contain;
      }
      input:not([type="checkbox"]):not([type="radio"]), select, textarea { font-size: 16px !important; }
    }`;
  const inlineCSS = `
    @media (max-width: 1024px) {
      input:not([type="checkbox"]):not([type="radio"]), select, textarea { font-size: 16px !important; }
    }`;
  const measure = () => {
    frame = 0;
    const next = document.querySelector('.halo-sticky-toolbar-mobile');
    if (next && next !== toolbar) {
      if (toolbar) resize.unobserve(toolbar);
      toolbar = next;
      resize.observe(toolbar);
    }
    const height = mobile.matches && toolbar && getComputedStyle(toolbar).display !== 'none'
      ? Math.ceil(toolbar.getBoundingClientRect().height) : 0;
    root.style.setProperty('--nekoan-mobile-nav-height', height + 'px');
    document.querySelectorAll('shopify-forms-embed').forEach(host => {
      if (!host.shadowRoot || installed.has(host)) return;
      const style = document.createElement('style');
      style.dataset.nekoanMobileUI = '';
      style.textContent = host.id.startsWith('app-embed-container-') ? floatingCSS : inlineCSS;
      host.shadowRoot.append(style);
      installed.add(host);
    });
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(measure); };
  const resize = new ResizeObserver(schedule);
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node =>
      node.nodeType === 1 && (node.matches('shopify-forms-embed,.halo-sticky-toolbar-mobile') ||
        node.querySelector('shopify-forms-embed,.halo-sticky-toolbar-mobile'))))) schedule();
  }).observe(document.body, {childList: true, subtree: true});
  mobile.addEventListener('change', schedule);
  window.addEventListener('resize', schedule, {passive: true});
  window.visualViewport?.addEventListener('resize', schedule, {passive: true});
  document.addEventListener('shopify:section:load', schedule);
  customElements.whenDefined('shopify-forms-embed').then(schedule);
  measure();
})();
